var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgThreeIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 23,
    r: 23,
    fill: "#7367F0",
    fillOpacity: 0.12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5515 21.775C25.4715 21.925 26.1765 22.27 26.6665 22.81C27.1565 23.34 27.4015 24 27.4015 24.79C27.4015 25.4 27.2415 25.965 26.9215 26.485C26.6015 26.995 26.1115 27.405 25.4515 27.715C24.8015 28.025 24.0015 28.18 23.0515 28.18C22.3115 28.18 21.5815 28.085 20.8615 27.895C20.1515 27.695 19.5465 27.415 19.0465 27.055L19.9915 25.195C20.3915 25.495 20.8515 25.73 21.3715 25.9C21.9015 26.06 22.4415 26.14 22.9915 26.14C23.6015 26.14 24.0815 26.025 24.4315 25.795C24.7815 25.555 24.9565 25.22 24.9565 24.79C24.9565 23.93 24.3015 23.5 22.9915 23.5H21.8815V21.895L24.0415 19.45H19.5715V17.5H26.9215V19.075L24.5515 21.775Z",
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreeIcon);
export default __webpack_public_path__ + "static/media/three-icon.6679ad79be63682041a2a9deb4250ebe.svg";
export { ForwardRef as ReactComponent };